import { NewRoleRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/roles/new')({
  component: NewRoleRoute,
});
